// jot_ta · tema propio (Atlas Systems, 21-oct-2026). Lo que se mueve en la tienda, sacado del boceto que aprobó Jota:
// el giro de las prendas (dos caras o, la gorra de Halloween, cuatro vistas), las tiras que se arrastran, la cuenta atrás,
// la ficha (tallas, colores, añadir al carrito sin recargar), el archivo, las pestañas de tallas y el carrito lateral.
window.JT = (() => {
  const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches

  // ── menú: una línea debajo al bajar ──────────────────────────
  const nav = document.getElementById('nav')
  if (nav) { const linea = () => nav.classList.toggle('con-linea', scrollY > 8); addEventListener('scroll', linea, { passive: true }); linea() }

  // ── tiras horizontales: sin barra (Jorge, 20-oct), así que con el ratón se arrastran. Si se ha arrastrado, el clic de
  // después no abre el enlace. Un solo par de escuchas en la ventana para todas: la tira del carrito lateral se vuelve a
  // pintar en cada cambio y no deben ir quedando escuchas (ni tiras viejas en memoria)
  let tirando = null
  addEventListener('pointermove', (e) => {
    const t = tirando; if (!t) return
    const dx = e.clientX - t.x
    if (!t.movido && Math.abs(dx) > 5) { t.movido = true; t.el.style.scrollSnapType = 'none'; t.el.classList.add('arrastrando') }
    if (t.movido) t.el.scrollLeft = t.s - dx
  })
  addEventListener('pointerup', () => {
    const t = tirando; if (!t) return
    tirando = null; t.el.style.scrollSnapType = t.snap; t.el.classList.remove('arrastrando')
    t.el._movido = t.movido; setTimeout(() => { t.el._movido = false }, 0)
  })
  function arrastrable(el) {
    if (!el || el.dataset.arrastrable === 'listo') return
    el.dataset.arrastrable = 'listo'; el.classList.add('arrastrable')
    el.addEventListener('dragstart', (e) => e.preventDefault())
    el.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return
      tirando = { el, x: e.clientX, s: el.scrollLeft, snap: el.style.scrollSnapType, movido: false }
    })
    el.addEventListener('click', (e) => { if (el._movido) { e.preventDefault(); e.stopPropagation() } }, true)
  }

  // ── el giro ──────────────────────────────────────────────────
  // g.ang es la vuelta de la prenda; g.paso, lo que hay de una cara a la siguiente (180, o 90 con cuatro vistas). Con
  // cuatro, cada cuarto de vuelta es un volteo entero de la lámina: la cara A lleva la vista 0 o la 2 y la B, la 1 o la 3,
  // y cada una se cambia mientras no se ve.
  const giros = new Set()
  let corriendo = false, cuenta = 0
  function activar(el, { invitar = false, alPasar = false, iman = true, estela = false, alCambiar = null } = {}) {
    if (!el || el._giro) return el && el._giro
    if (el.classList.contains('giro--quieta')) return null
    const g = el._giro = { el, escena: el.querySelector('.giro__escena'), pieza: el.querySelector('.giro__pieza'), ang: 0, vel: 0, arrastre: false, tocado: false, tween: null, invitar: invitar && !quieto, iman, enB: false, cara: 0, alCambiar, t0: performance.now() }
    let vistas = null
    try { vistas = el.dataset.vistas ? JSON.parse(el.dataset.vistas) : null } catch (e) {}
    g.paso = vistas && vistas.length === 4 ? 90 : 180
    if (g.paso === 90) {
      g.vistas = vistas
      // se precargan con el sizes de su foto: sin él, el navegador las pide al ancho de la pantalla
      const tam = el.querySelector('.giro__cara--a img')?.getAttribute('sizes') || ''
      vistas.forEach((v) => { const im = new Image(); im.sizes = tam; im.srcset = v.srcset || ''; im.src = v.src })
      g.imgs = [el.querySelector('.giro__cara--a img'), el.querySelector('.giro__cara--b img')]; g.puestas = [0, 1]
    }
    if (estela && !quieto) {
      g.id = 'estela-' + (++cuenta)
      document.body.insertAdjacentHTML('beforeend', `<svg class="filtro-estela" width="0" height="0" aria-hidden="true"><filter id="${g.id}" x="-30%" width="160%"><feGaussianBlur stdDeviation="0 0"/></filter></svg>`)
      g.blur = document.querySelector(`#${g.id} feGaussianBlur`)
    }
    el.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return
      g.arrastre = true; g.tocado = true; g.tween = null; g.x0 = g.x = e.clientX; g.tMov = performance.now(); g.movido = false
      g.k = 330 / Math.max(el.clientWidth, 220)
      el.setPointerCapture(e.pointerId); el.classList.add('arrastrando'); despertar()
    })
    el.addEventListener('pointermove', (e) => {
      if (!g.arrastre) return
      const dx = e.clientX - g.x; g.x = e.clientX; g.tMov = performance.now()
      if (Math.abs(e.clientX - g.x0) > 6) g.movido = true
      const d = dx * g.k; g.ang += d; g.vel = g.vel * 0.4 + d * 0.6
    })
    const soltar = () => {
      if (!g.arrastre) return
      g.arrastre = false; el.classList.remove('arrastrando')
      if (performance.now() - g.tMov > 90) g.vel = 0
      despertar()
    }
    el.addEventListener('pointerup', soltar); el.addEventListener('pointercancel', soltar); el.addEventListener('lostpointercapture', soltar)
    el.addEventListener('click', (e) => { if (g.movido) { e.preventDefault(); e.stopPropagation(); g.movido = false } }, true)
    el.addEventListener('dragstart', (e) => e.preventDefault())
    el.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return
      e.preventDefault(); g.tocado = true; const s = e.key === 'ArrowLeft' ? -1 : 1
      ir(g.vistas ? (g.cara + s + 4) % 4 : !g.enB, s)
    })
    // al pasar el ratón: la posición en horizontal marca el ángulo (todo el ancho es una vuelta) y se queda más rato en
    // cada cara, donde mejor se ve. Al salir, vuelve de frente
    if (alPasar) {
      el.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && !quieto) { g.raton = true; g.tocado = true; g.tween = null } })
      el.addEventListener('pointermove', (e) => {
        if (!g.raton || g.arrastre) return
        const r = el.getBoundingClientRect(), x = Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1), n = 360 / g.paso
        g.objetivo = (x - Math.sin(2 * n * Math.PI * x) / (2 * n * Math.PI)) * 360; despertar()
      })
      el.addEventListener('pointerleave', (e) => { if (e.pointerType !== 'mouse' || !g.raton) return; g.raton = false; g.objetivo = null; ir(false) })
    }
    // a una cara concreta (false o true, o el número de vista), por el camino corto o en el sentido pedido
    function ir(cara, sentido = 0) {
      const obj = +cara * g.paso, k = Math.round((g.ang - obj) / 360)
      let opciones = [k - 1, k, k + 1].map((n) => obj + 360 * n)
      if (sentido) opciones = opciones.filter((a) => (a - g.ang) * sentido > 1)
      const a = opciones.sort((x, y) => Math.abs(x - g.ang) - Math.abs(y - g.ang))[0]
      g.tocado = true; g.tween = { de: g.ang, a, t0: performance.now(), dur: quieto ? 1 : 850 }; despertar()
    }
    g.ir = ir
    giros.add(g); despertar()
    return g
  }
  function pintar(g) {
    g.el.dataset.angulo = g.ang.toFixed(1)
    const c = (g.ang * 180) / g.paso
    g.pieza.style.transform = `rotateY(${c.toFixed(2)}deg)`
    if (g.vistas) {
      const pon = [(((Math.round(g.ang / 180) * 2) % 4) + 4) % 4, (((Math.round((g.ang - 90) / 180) * 2 + 1) % 4) + 4) % 4]
      pon.forEach((v, i) => {
        if (v === g.puestas[i] || !g.imgs[i]) return
        g.puestas[i] = v; g.imgs[i].srcset = g.vistas[v].srcset || ''; g.imgs[i].src = g.vistas[v].src
      })
    }
    if (g.blur) {
      const b = Math.min(Math.abs(g.vel) * (180 / g.paso) * 0.85, 14)
      if (b > 0.5) { g.blur.setAttribute('stdDeviation', `${b.toFixed(1)} 0`); g.escena.style.filter = `url(#${g.id})` } else if (g.escena.style.filter) g.escena.style.filter = ''
    }
    const n = ((c % 360) + 360) % 360, b = n > 90 && n < 270
    if (b !== g.enB) { g.enB = b; g.el.classList.toggle('en-b', b) }
    const cara = g.vistas ? ((Math.round(g.ang / 90) % 4) + 4) % 4 : +b
    if (cara !== g.cara) { g.cara = cara; if (g.alCambiar) g.alCambiar(cara) }
  }
  function bucle(t) {
    let sigue = false
    for (const g of giros) {
      if (!g.el.isConnected) { giros.delete(g); continue }
      if (g.tween) {
        const k = Math.min((t - g.tween.t0) / g.tween.dur, 1), e = 1 - Math.pow(1 - k, 3)
        const nuevo = g.tween.de + (g.tween.a - g.tween.de) * e
        g.vel = nuevo - g.ang; g.ang = nuevo
        if (k >= 1) { g.tween = null; g.vel = 0 }
      } else if (g.objetivo != null && !g.arrastre) {
        const d = ((((g.objetivo - g.ang) % 360) + 540) % 360) - 180
        g.vel = Math.abs(d) > 0.05 ? d * 0.2 : d; g.ang += g.vel
      } else if (!g.arrastre) {
        if (Math.abs(g.vel) > 0.08) { g.ang += g.vel; g.vel *= 0.93 }
        else {
          g.vel = 0
          if (g.invitar && !g.tocado) g.ang = 18 * (g.paso / 180) * Math.sin((t - g.t0) / 650)
          else if (g.iman) { const d = Math.round(g.ang / g.paso) * g.paso - g.ang; g.ang = Math.abs(d) > 0.05 ? g.ang + d * 0.14 : g.ang + d }
        }
      }
      pintar(g)
      if (g.arrastre || g.tween || g.vel || g.raton || (g.invitar && !g.tocado) || (g.iman && Math.abs(Math.round(g.ang / g.paso) * g.paso - g.ang) > 0.01)) sigue = true
    }
    if (sigue) requestAnimationFrame(bucle); else corriendo = false
  }
  const despertar = () => { if (!corriendo) { corriendo = true; requestAnimationFrame(bucle) } }
  // los giros de la página que no necesitan nada más (rejillas): data-giro="pasar" gira al pasar el ratón
  const activarTodo = (raiz = document) => raiz.querySelectorAll('.giro[data-giro]').forEach((el) => {
    // los del carrito lateral arrancan al abrirlo (abrir()): cerrado no se ven, y la gorra precargaría sus cuatro vistas
    if (el.closest('dialog:not([open])')) return
    const m = el.dataset.giro
    activar(el, { alPasar: m.includes('pasar'), invitar: m.includes('invitar'), estela: !m.includes('sin-estela') })
  })

  // ── aparición al bajar ───────────────────────────────────────
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('visto'); io.unobserve(e.target) } }), { rootMargin: '0px 0px -8% 0px' }) : null
  const aparecer = (raiz = document) => raiz.querySelectorAll('.aparece:not(.visto)').forEach((el) => (io ? io.observe(el) : el.classList.add('visto')))

  // ── cuentas atrás, cada una hasta su fecha ───────────────────
  const dos = (n) => String(n).padStart(2, '0')
  const relojes = [...document.querySelectorAll('[data-hasta]')].map((el) => [el, new Date(el.dataset.hasta).getTime()]).filter(([, h]) => !isNaN(h))
  function contar() {
    for (const [el, hasta] of relojes) {
      let s = Math.max(0, Math.floor((hasta - Date.now()) / 1000))
      const d = Math.floor(s / 86400); s %= 86400
      const h = Math.floor(s / 3600); s %= 3600
      const m = Math.floor(s / 60), sg = s % 60
      el.innerHTML = [[d, 'Días'], [h, 'Horas'], [m, 'Min'], [sg, 'Seg']].map(([n, t]) => `<div><b>${dos(n)}</b><span class="suave">${t}</span></div>`).join('')
    }
  }
  if (relojes.length) { contar(); setInterval(contar, 1000) }

  // ── carrito: el número del menú ──────────────────────────────
  async function pintarCarrito() {
    try {
      const c = await (await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })).json()
      document.querySelectorAll('[data-carrito-n]').forEach((el) => { el.textContent = `(${c.item_count})` })
    } catch (e) {}
  }

  // ── la ficha de una prenda ───────────────────────────────────
  function ficha(raiz) {
    if (!raiz) return
    const giro = raiz.querySelector('.ficha__vista .giro')
    const botones = raiz.querySelectorAll('[data-cara]')
    const g = activar(giro, { invitar: true, estela: true, alCambiar: (k) => botones.forEach((b) => b.classList.toggle('activa', +b.dataset.cara === +k)) })
    raiz.querySelector('.caras')?.addEventListener('click', (e) => { const b = e.target.closest('[data-cara]'); if (b && g) g.ir(+b.dataset.cara) })

    // variantes: las opciones (talla, color) eligen la variante; el precio, el botón y, si la variante lleva su foto, la
    // cara A cambian con ella
    const form = raiz.querySelector('form.form-prenda')
    const datos = raiz.querySelector('script[data-variantes]')
    if (form && datos) {
      const variantes = JSON.parse(datos.textContent)
      const id = form.querySelector('input[name="id"]'), boton = form.querySelector('[data-anadir]'), precio = raiz.querySelector('[data-precio]')
      const elegidas = () => [...form.querySelectorAll('.opciones:not([data-fija])')].map((o) => (o.querySelector('input:checked') || {}).value)
      let enviando = false
      const elegir = () => {
        const sel = elegidas(), v = variantes.find((x) => x.opciones.every((o, i) => sel[i] == null || o === sel[i]))
        if (!v) { boton.disabled = true; boton.textContent = 'No hay esta combinación'; return }
        id.value = v.id
        if (precio) precio.textContent = v.precio
        boton.disabled = !v.disponible; boton.textContent = v.disponible ? boton.dataset.texto : 'Agotado'
        raiz.querySelectorAll('[data-aviso-agotada]').forEach((x) => {
          x.hidden = v.disponible
          // la talla que quería va en la etiqueta del aviso (aviso-<prenda>-<talla>), para saber qué tallas pedir
          const t = x.querySelector('input[name="contact[tags]"]'), talla = v.opciones.filter((o) => o !== 'Default Title').join('-')
          if (t && x.dataset.avisoBase) t.value = x.dataset.avisoBase + (talla ? `, aviso-${x.dataset.avisoPrenda}-${talla}` : '')
        })
        if (v.foto && giro) {
          const im = giro.querySelector('.giro__cara--a img')
          if (im && im.dataset.foto !== v.foto.src) { im.srcset = v.foto.srcset; im.src = v.foto.src; im.dataset.foto = v.foto.src }
        }
        // mientras se añade, el botón sigue quieto aunque se cambie de talla: si no, se podría tocar otra vez a medias
        if (enviando) { boton.disabled = true; boton.textContent = 'Añadiendo…' }
        try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u) } catch (e) {}
      }
      form.addEventListener('change', (e) => {
        if (!e.target.closest('.opciones')) return
        // otra talla: el aviso de la de antes («se acaba de agotar») ya no vale para esta
        const m = raiz.querySelector('[data-error]'); if (m) m.hidden = true
        elegir()
      })
      // añadir sin recargar: se abre el carrito lateral con la prenda dentro (sin JavaScript, Shopify lleva al carrito)
      form.addEventListener('submit', async (e) => {
        if (!window.fetch) return
        e.preventDefault()
        if (enviando) return
        const m = raiz.querySelector('[data-error]'), v = variantes.find((x) => x.id === +id.value)
        enviando = true; boton.disabled = true; boton.textContent = 'Añadiendo…'; if (m) m.hidden = true
        // lo que la ficha manda con la prenda (properties, como el plazo de una preorder) va en su línea: así sale en el
        // carrito, al pagar y en el pedido
        const propiedades = {}
        new FormData(form).forEach((valor, k) => { const p = /^properties\[(.+)\]$/.exec(k); if (p && valor) propiedades[p[1]] = valor })
        try {
          await anadir([{ id: +id.value, quantity: 1, ...(Object.keys(propiedades).length ? { properties: propiedades } : {}) }])
          enviando = false
          boton.textContent = '¡Añadida!'; raiz.querySelector('.anadido')?.classList.add('visto')
          // al rato, el botón vuelve a lo que toque para la talla que esté elegida entonces
          setTimeout(elegir, 1600)
        } catch (err) {
          enviando = false
          // agotada mientras mirabas (alguien se ha llevado la última): aquí también pasa a agotada, con el aviso. Se tacha la
          // talla que se pidió, que puede no ser la que está marcada ahora (se puede cambiar mientras se añade)
          const talla = v ? v.opciones.filter((o) => o !== 'Default Title').join(' / ') : ''
          if (err.agotada && v) {
            v.disponible = false
            const grupos = form.querySelectorAll('.opciones:not([data-fija])')
            if (grupos.length === 1) grupos[0].querySelectorAll('input').forEach((i) => { if (i.value === v.opciones[0]) i.closest('label')?.classList.add('agotada') })
          }
          elegir()
          if (m) { m.textContent = err.agotada && talla ? `La ${talla} se acaba de agotar.` : err.message; m.hidden = false }
        }
      })
    }
    // las fotos de verdad, en grande al tocarlas
    const ver = raiz.querySelector('dialog.verfoto'), reales = raiz.querySelector('.reales')
    if (ver && reales) {
      arrastrable(reales)
      reales.addEventListener('click', (e) => { const b = e.target.closest('button'); if (!b) return; ver.innerHTML = `<img src="${b.dataset.grande}" alt="${b.dataset.alt || ''}">`; ver.showModal() })
      ver.addEventListener('click', () => ver.close())
    }
  }

  // ── el archivo: el índice numerado, la vista de la prenda y la línea de los drops ──
  function archivo(raiz) {
    if (!raiz) return
    const vista = raiz.querySelector('.vista'), linea = raiz.querySelector('.linea__pista'), zukan = raiz.querySelector('.zukan')
    const grande = () => matchMedia('(min-width: 901px)').matches
    let elegida = null
    const ensenar = (e) => {
      elegida = e
      const t = e.querySelector('template[data-vista]'); if (!t || !vista) return
      vista.replaceChildren(t.content.cloneNode(true)); activar(vista.querySelector('.giro'), { estela: true })
      raiz.querySelectorAll('.entrada').forEach((x) => x.classList.toggle('activa', x === e))
    }
    raiz.querySelectorAll('.entrada').forEach((e) => {
      e.addEventListener('mouseenter', () => { if (grande() && matchMedia('(hover: hover)').matches && elegida !== e) ensenar(e) })
      e.addEventListener('click', (ev) => {
        if (ev.target.closest('.giro, a')) return
        if (grande()) { location.href = e.dataset.url; return }
        // en el móvil se abre ahí mismo, con su giro
        const abierta = e.classList.contains('activa')
        raiz.querySelectorAll('.entrada.activa').forEach((x) => { x.classList.remove('activa'); x.querySelector('.entrada__mas').replaceChildren() })
        if (abierta) return
        e.classList.add('activa')
        const t = e.querySelector('template[data-movil]'), mas = e.querySelector('.entrada__mas')
        if (t && mas) { mas.replaceChildren(t.content.cloneNode(true)); activar(mas.querySelector('.giro'), { estela: true }) }
      })
    })
    if (linea) {
      arrastrable(linea)
      linea.addEventListener('click', (e) => { const b = e.target.closest('button'); if (b) document.getElementById('d-' + b.dataset.c)?.scrollIntoView({ behavior: 'smooth' }) })
      const marcar = (c) => linea.querySelectorAll('button').forEach((b) => {
        const si = b.dataset.c === c; b.classList.toggle('activo', si)
        if (si) linea.scrollTo({ left: b.offsetLeft - linea.clientWidth / 2 + b.offsetWidth / 2, behavior: 'smooth' })
      })
      if (io) {
        const obs = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) marcar(en.target.dataset.c) }), { rootMargin: `-${Math.round(innerHeight * 0.3)}px 0px -60% 0px` })
        raiz.querySelectorAll('.tramo').forEach((t) => obs.observe(t))
      }
    }
    raiz.querySelector('.orden')?.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b) return
      raiz.querySelectorAll('.orden button').forEach((x) => x.classList.toggle('activa', x === b))
      zukan.classList.toggle('al-reves', b.dataset.o === '-1')
      if (linea) linea.style.flexDirection = b.dataset.o === '-1' ? 'row-reverse' : ''
    })
    const primera = raiz.querySelector('.entrada[data-inicial]') || raiz.querySelector('.entrada')
    if (grande() && primera) ensenar(primera)
    const ir = decodeURIComponent(location.hash.slice(1))
    if (ir && document.getElementById(ir)) setTimeout(() => document.getElementById(ir).scrollIntoView(), 50)
  }

  // ── pestañas de la guía de tallas ────────────────────────────
  function pestanas(raiz) {
    raiz.querySelectorAll('[data-pestanas]').forEach((p) => p.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b) return
      p.querySelectorAll('button').forEach((x) => x.classList.toggle('activa', x === b))
      raiz.querySelectorAll('.tipo-tallas').forEach((t) => { t.hidden = t.dataset.tipo !== b.dataset.tipo })
    }))
  }

  // ── carrito: + y −, y se manda solo ─────────────────────────
  function carrito(raiz) {
    const form = raiz && raiz.querySelector('form[data-carrito]'); if (!form) return
    form.addEventListener('click', (e) => {
      const b = e.target.closest('[data-mas], [data-menos]'); if (!b) return
      e.preventDefault()
      const inp = b.parentElement.querySelector('input'); inp.value = Math.max(0, (+inp.value || 0) + (b.hasAttribute('data-mas') ? 1 : -1))
      form.requestSubmit ? form.requestSubmit() : form.submit()
    })
    form.addEventListener('change', (e) => { if (e.target.matches('.cantidad input')) form.requestSubmit ? form.requestSubmit() : form.submit() })
    // vuelve de la caché del navegador (atrás): sus cantidades pueden ser viejas y el + las pisaría. Se pide otra vez
    addEventListener('pageshow', (e) => { if (e.persisted) location.reload() })
  }

  // ── el carrito lateral (Jorge, 22-oct): se abre al tocar el carrito y al añadir algo; la página /cart solo se ve
  // escribiéndola a mano. Lo de dentro lo pinta Shopify (snippets/cajon-carrito.liquid, por la sección cajon-carrito):
  // cada cambio pide el carrito ya pintado en la misma llamada y aquí solo se cambia lo de dentro del cajón. Sin el cajón
  // (la puerta) o sin <dialog>, el carrito es la página de siempre
  const RAIZ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'
  const SECCION = 'cajon-carrito'
  const sinBarra = (p) => p.replace(/\/+$/, '') || '/'
  const rutaCarrito = sinBarra(RAIZ + 'cart')
  const cajon = { el: null, ocupado: false, antes: null, cerrando: 0, recargando: false }
  // los cambios del carrito van en fila: lo que se pinta siempre es la respuesta del último, nunca una vieja encima. Se cuentan
  // los que faltan, para que «Pagar» espere a que acaben
  let cola = Promise.resolve(), pendientes = 0
  const enCola = (tarea) => {
    pendientes++
    const t = cola.then(() => tarea()).finally(() => { pendientes-- })
    cola = t.catch(() => {}); return t
  }
  // una petición sin respuesta en 15 s se da por fallida: en el navegador de Instagram, al cambiar de red, puede quedarse
  // colgada, y con ella todo el carrito, que va en fila. Devuelve la respuesta y su JSON (null si no lo es)
  async function traer(url, opciones = {}) {
    const ctl = window.AbortController ? new AbortController() : null
    const reloj = ctl ? setTimeout(() => ctl.abort(), 15000) : 0
    try {
      const r = await fetch(url, ctl ? { ...opciones, signal: ctl.signal } : opciones)
      let j = null
      try { j = await r.json() } catch (e) { if (ctl && ctl.signal.aborted) throw e }
      return { r, j }
    } finally { clearTimeout(reloj) }
  }

  function contarCarrito(n) {
    document.querySelectorAll('[data-carrito-n]').forEach((el) => {
      const t = `(${n})`; if (el.textContent === t) return
      el.textContent = t; el.classList.remove('salta'); void el.offsetWidth; el.classList.add('salta')
    })
  }
  function pintarCajon(html, abrirTras = false) {
    const d = cajon.el; if (!d || !html || cajon.recargando) return null
    const nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('.cajon__dentro'); if (!nuevo) return null
    const viejo = d.querySelector('.cajon__dentro')
    // el tema ha cambiado con la página abierta (se ha publicado algo): lo nuevo no casa con los estilos ni el código de esta
    // página (Jorge lo vio el 23-oct: dos columnas y las dos caras a la vez). Se recarga, y si el cajón estaba abierto o se
    // estaba añadiendo, se vuelve a abrir solo. Como mucho una vez cada 30 s, por si la marca no fuese estable
    if (viejo && viejo.dataset.version && nuevo.dataset.version && viejo.dataset.version !== nuevo.dataset.version) {
      let ultima = 0
      try { ultima = +sessionStorage.getItem('jt-recarga') || 0 } catch (e) {}
      if (Date.now() - ultima > 30000) {
        try { sessionStorage.setItem('jt-recarga', String(Date.now())); if (d.open || abrirTras) sessionStorage.setItem('jt-cajon', '1') } catch (e) {}
        cajon.recargando = true; location.reload(); return null
      }
    }
    const antes = viejo && { sc: viejo.querySelector('.cajon__cuerpo')?.scrollTop || 0, total: viejo.querySelector('[data-cajon-total]')?.textContent, n: viejo.querySelector('[data-cajon-n]')?.textContent }
    if (viejo) viejo.replaceWith(nuevo); else d.prepend(nuevo)
    if (antes) {
      const c = nuevo.querySelector('.cajon__cuerpo'); if (c) c.scrollTop = antes.sc
      // el total y el número, si cambian, entran con un golpe
      for (const [k, sel] of [['total', '[data-cajon-total]'], ['n', '[data-cajon-n]']]) {
        const el = nuevo.querySelector(sel); if (el && antes[k] != null && el.textContent !== antes[k]) el.classList.add('cambia')
      }
    }
    if (d.open) cargarFotos(nuevo)
    activarTodo(nuevo); nuevo.querySelectorAll('[data-arrastrable]').forEach(arrastrable)
    contarCarrito(+nuevo.dataset.cuenta || 0)
    return nuevo
  }
  // una lista de { id, quantity } va en JSON; el formulario de una prenda, entero (con sus propiedades)
  async function pedir(ruta, datos) {
    const headers = { Accept: 'application/json' }
    let body
    if (datos instanceof FormData) { body = datos; body.append('sections', SECCION); body.append('sections_url', location.pathname) }
    else { body = JSON.stringify({ ...datos, sections: SECCION, sections_url: location.pathname }); headers['Content-Type'] = 'application/json' }
    const { r, j } = await traer(RAIZ + ruta, { method: 'POST', headers, body })
    // un 200 que no trae un carrito (una página de espera o de comprobación de Shopify) no ha cambiado nada
    if (!r.ok || !j || (!j.items && !j.id)) {
      const er = new Error((j && (j.description || j.message)) || 'No se ha podido actualizar el carrito.'); er.estado = r.ok ? 0 : r.status; throw er
    }
    return j
  }
  // el carrito de verdad, sin cambiar nada; devuelve lo pintado (o null)
  async function refrescar(abrirTras = false) {
    try {
      const { r, j } = await traer(`${RAIZ}?sections=${SECCION}`, { headers: { Accept: 'application/json' } })
      if (r.ok && j) return pintarCajon(j[SECCION], abrirTras)
    } catch (e) {}
    return null
  }
  // lo que llega pintado en la respuesta; si Shopify no lo pinta, se pide aparte, y si tampoco, se recarga la página: el
  // cajón nunca enseña un carrito que no es. El cambio ya está hecho, así que al volver se abre el cajón para que se vea
  async function repintar(html) {
    const nodo = pintarCajon(html, true) || (cajon.recargando ? null : await refrescar(true))
    if (!nodo && !cajon.recargando) {
      try { sessionStorage.setItem('jt-cajon', '1') } catch (e) {}
      cajon.recargando = true; location.reload()
    }
    return nodo
  }
  // las fotos del cajón llegan sin cargar (data-src): Chrome las bajaría con el cajón cerrado, en cada página. Se cargan al
  // abrirlo, o antes, al acercarse al carrito del menú
  function cargarFotos(raiz) {
    if (!raiz) return
    raiz.querySelectorAll('img[data-src]').forEach((i) => {
      if (i.dataset.srcset) i.srcset = i.dataset.srcset
      i.src = i.dataset.src; i.removeAttribute('data-src'); i.removeAttribute('data-srcset')
    })
  }
  function decir(texto) {
    const v = cajon.el && cajon.el.querySelector('[data-cajon-voz]'); if (!v) return
    v.textContent = ''; setTimeout(() => { v.textContent = texto }, 60)
  }
  function avisoEn(el, texto) {
    const p = el && el.querySelector('[data-aviso]'); if (!p || !texto) return
    p.textContent = texto; p.hidden = false
  }
  function abrir() {
    const d = cajon.el; if (!d) return false
    clearTimeout(cajon.cerrando)
    if (!d.open) {
      cajon.antes = document.activeElement
      d.showModal(); document.documentElement.classList.add('con-cajon')
      if (!quieto) { d.classList.add('entrando'); setTimeout(() => d.classList.remove('entrando'), 1100) }
    }
    cargarFotos(d); activarTodo(d)
    void d.offsetWidth; d.classList.add('abierto')
    // el foco, en el título (sin recuadro): Safari lo pinta en el botón aunque se haya abierto tocando
    d.querySelector('#cajon-titulo')?.focus({ preventScroll: true })
    return true
  }
  function cerrar() {
    const d = cajon.el; if (!d || !d.open) return
    d.classList.remove('abierto', 'entrando'); clearTimeout(cajon.cerrando)
    cajon.cerrando = setTimeout(() => d.close(), quieto ? 0 : 330)
  }
  // la que acaba de entrar: se ve, da una vuelta entera y lleva su sello un momento
  function recibir(li) {
    if (!li) return
    li.classList.add('nueva'); li.scrollIntoView({ block: 'nearest', behavior: quieto ? 'auto' : 'smooth' })
    const g = li.querySelector('.giro')?._giro
    if (g && !quieto) { g.tocado = true; g.tween = { de: g.ang, a: g.ang + 360, t0: performance.now(), dur: 1100 }; despertar() }
    setTimeout(() => li.classList.remove('nueva'), 2600)
  }
  // un 422 al añadir: o ya están todas en el carrito, o se acaba de agotar (alguien se ha llevado la última). El texto de
  // Shopify dice cuántas quedan, y Jota no quiere unidades a la vista (20-oct)
  async function porQueNo(err, id) {
    let e
    if (err.estado === 422) {
      let dentro = false
      try { const { j: c } = await traer(RAIZ + 'cart.js', { headers: { Accept: 'application/json' } }); dentro = ((c && c.items) || []).some((x) => x.variant_id === id) } catch (er) {}
      e = new Error(dentro ? 'Ya tienes en el carrito todas las que quedan.' : 'Se acaba de agotar.'); e.agotada = !dentro
    } else e = new Error('No se ha podido añadir. Prueba otra vez.')
    e.estado = err.estado
    return e
  }
  // añade (una lista de { id, quantity } o el FormData de un formulario), pinta el cajón, lo abre y enseña la que entra
  function anadir(items) {
    const forma = items instanceof FormData, id = forma ? +items.get('id') : +items[0].id
    return enCola(async () => {
      const cuantas = () => +((cajon.el && cajon.el.querySelector(`.cajon__linea[data-variante="${id}"]`)?.dataset.q) || 0)
      const antes = cuantas()
      let j
      try { j = await pedir('cart/add.js', forma ? items : { items }) } catch (err) {
        // sin respuesta clara (sin red, 15 s, un error de Shopify) puede que sí haya entrado: se mira el carrito de verdad y, si
        // ha entrado, cuenta como añadida, para que al reintentar no se añada dos veces. Dos veces, al momento y al segundo:
        // justo después de añadir, el carrito a veces aún no lo enseña (visto el 28-oct)
        if (err.estado !== 422 && cajon.el) {
          for (const espera of [0, 1200]) {
            if (espera) await new Promise((ok) => setTimeout(ok, espera))
            if ((await refrescar()) && cuantas() > antes) {
              abrir(); recibir(cajon.el.querySelector(`.cajon__linea[data-variante="${id}"]`))
              return {}
            }
          }
        }
        throw await porQueNo(err, id)
      }
      if (!cajon.el) { pintarCarrito(); return j }
      const raiz = await repintar(j.sections && j.sections[SECCION]); if (!raiz) return j
      abrir()
      recibir([...raiz.querySelectorAll('.cajon__linea')].find((x) => x.dataset.variante === String(id)))
      const it = j.items ? j.items[0] : j
      if (it && it.product_title) decir(`Añadida al carrito: ${it.product_title}${it.variant_title ? ', ' + it.variant_title : ''}.`)
      return j
    })
  }
  async function cambiar(b) {
    const li = b.closest('[data-linea]'); if (!li || cajon.ocupado) return
    const clave = li.dataset.linea, q = +li.dataset.q || 0, accion = b.dataset.cambio, teclado = b.matches(':focus-visible')
    const quiero = accion === 'mas' ? q + 1 : accion === 'menos' ? q - 1 : 0
    cajon.ocupado = true; li.classList.add('cambiando')
    const fuera = quiero === 0 && !quieto && li.animate ? li.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(28px)' }], { duration: 220, easing: 'cubic-bezier(.2, .7, .2, 1)', fill: 'forwards' }).finished.catch(() => {}) : null
    try {
      await enCola(async () => {
        const [j] = await Promise.all([pedir('cart/change.js', { id: clave, quantity: quiero }), fuera])
        const raiz = await repintar(j.sections && j.sections[SECCION]); if (!raiz) return
        const nueva = [...raiz.querySelectorAll('[data-linea]')].find((x) => x.dataset.linea === clave)
        const queda = (j.items || []).find((x) => x.key === clave)
        if (nueva && quiero > q && queda && queda.quantity < quiero) avisoEn(nueva, nueva.dataset.tope)
        decir(quiero === 0 ? 'Quitada del carrito.' : 'Carrito actualizado.')
        // el foco: con el teclado, donde estaba (o en cerrar, si la línea ya no está); tocando, en el título, sin recuadro
        const otro = teclado && nueva && nueva.querySelector(`[data-cambio="${accion}"]`)
        const foco = otro && !otro.disabled ? otro : raiz.querySelector(teclado ? '[data-cajon-cerrar]' : '#cajon-titulo')
        if (foco) foco.focus({ preventScroll: true })
      })
    } catch (err) {
      if (li.getAnimations) li.getAnimations().forEach((a) => a.cancel())
      // se pinta el carrito de verdad: con un 422 (no quedan tantas) Shopify no lo deja como estaba, pone las que quedan
      // (comprobado el 28-oct: de 1 a 18 al pedir 999); y en lo demás la línea puede no estar o el carrito haber cambiado en
      // otra pestaña. En el 422, el aviso va en su línea ya pintada
      const raiz = await enCola(refrescar)
      const nueva = raiz && [...raiz.querySelectorAll('[data-linea]')].find((x) => x.dataset.linea === clave)
      if (err.estado === 422) { if (nueva) avisoEn(nueva, nueva.dataset.tope); else if (!raiz) { li.classList.remove('cambiando'); avisoEn(li, li.dataset.tope) } }
      else if (!raiz) { li.classList.remove('cambiando'); avisoEn(li, 'No se ha podido cambiar. Prueba otra vez.') }
    } finally { cajon.ocupado = false }
  }
  // «Completa el drop»: con la talla marcada (la que ya eligió, si la hay), o sin talla en la gorra
  async function sumar(s) {
    const card = s.closest('[data-extra]'); if (!card || cajon.ocupado) return
    const marcada = card.querySelector('input[type="radio"]:checked'), id = +(s.dataset.variante || (marcada && marcada.value))
    if (!id) { card.classList.remove('sin-talla'); void card.offsetWidth; card.classList.add('sin-talla'); avisoEn(card, 'Elige una talla.'); return }
    cajon.ocupado = true; s.disabled = true; s.textContent = 'Añadiendo…'
    try { await anadir([{ id, quantity: 1 }]) } catch (err) {
      if (s.isConnected) {
        avisoEn(card, err.message)
        // agotada mientras mirabas: esa talla (o la gorra entera) ya no se puede elegir
        if (err.agotada) { if (marcada) { marcada.checked = false; marcada.disabled = true } else s.dataset.agotado = '1' }
      }
    } finally {
      cajon.ocupado = false
      if (s.isConnected) { s.disabled = !!s.dataset.agotado; s.textContent = s.dataset.agotado ? 'Agotado' : '+ Añadir' }
    }
  }
  function cajonListo() {
    const d = document.getElementById('cajon')
    if (!d || typeof d.showModal !== 'function' || !window.fetch || !window.DOMParser) return
    cajon.el = d
    d.addEventListener('cancel', (e) => { e.preventDefault(); cerrar() })
    d.addEventListener('close', () => {
      // el aviso de cerrado llega un poco después: si entretanto se ha vuelto a abrir, no se toca nada
      if (d.open) return
      clearTimeout(cajon.cerrando); d.classList.remove('abierto', 'entrando'); document.documentElement.classList.remove('con-cajon')
      const a = cajon.antes; cajon.antes = null
      if (a && a.isConnected && a.focus) a.focus({ preventScroll: true })
    })
    d.addEventListener('click', (e) => {
      if (e.target === d || e.target.closest('[data-cajon-cerrar]')) { cerrar(); return }
      const ver = e.target.closest('[data-ver-drop]')
      if (ver && sinBarra(location.pathname) === sinBarra(RAIZ)) {
        e.preventDefault(); cerrar()
        const drop = document.querySelector('.drop'); if (drop) setTimeout(() => drop.scrollIntoView({ behavior: quieto ? 'auto' : 'smooth' }), 340)
        return
      }
      const b = e.target.closest('[data-cambio]'); if (b) { cambiar(b); return }
      const s = e.target.closest('[data-sumar]'); if (s) sumar(s)
    })
    // el carrito del menú (y cualquier enlace a /cart) abre el cajón; con Cmd o Ctrl, o desde la propia página, va a /cart
    document.addEventListener('click', (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
      const a = e.target.closest && e.target.closest('a[href]'); if (!a || (a.target && a.target !== '_self')) return
      let u; try { u = new URL(a.href, location.href) } catch (er) { return }
      if (u.origin !== location.origin || sinBarra(u.pathname) !== rutaCarrito || sinBarra(location.pathname) === rutaCarrito) return
      e.preventDefault(); abrir()
    })
    // cualquier otro formulario de añadir (la ficha lleva el suyo) también abre el cajón en vez de ir a /cart. Va entero,
    // con sus propiedades; el botón, quieto mientras tanto; y solo si no hay red se manda como siempre
    document.addEventListener('submit', (e) => {
      const f = e.target
      if (e.defaultPrevented || !f.matches || !f.matches('form[action*="/cart/add"]')) return
      const datos = new FormData(f); if (!+datos.get('id')) return
      e.preventDefault()
      const boton = e.submitter; if (boton) boton.disabled = true
      anadir(datos).catch((err) => {
        if (err.estado === undefined) { f.submit(); return }
        const m = f.querySelector('[data-error]'); if (m) { m.textContent = err.message; m.hidden = false }
      }).finally(() => { if (boton) boton.disabled = false })
    })
    // pagar con un cambio del carrito a medias (quitar, +, −, añadir): primero se espera a que acabe, para que el pago lleve el
    // carrito de verdad. Entretanto el cajón se vuelve a pintar, así que después se toca el «Pagar» nuevo
    d.addEventListener('submit', (e) => {
      if (!pendientes || !e.target.querySelector('button[name="checkout"]')) return
      e.preventDefault()
      if (e.submitter) { e.submitter.disabled = true; const t = e.submitter.querySelector('span'); if (t) t.textContent = 'Un momento…' }
      cola.then(() => { const b = d.querySelector('button[name="checkout"]'); if (b) { b.disabled = false; b.click() } })
    })
    // las fotos, en cuanto el ratón, el dedo o el teclado se acercan al carrito del menú
    const antesDeAbrir = (e) => { if (e.target.closest && e.target.closest('.nav__carrito')) cargarFotos(d) }
    for (const ev of ['pointerover', 'focusin', 'touchstart']) document.addEventListener(ev, antesDeAbrir, { passive: true })
    // al volver de la caché del navegador o de otra pestaña, el carrito puede haber cambiado
    addEventListener('pageshow', (e) => { if (e.persisted) enCola(refrescar) })
    // vuelve de una recarga por cambio de tema con el cajón abierto (o añadiendo): se abre otra vez
    try { if (sessionStorage.getItem('jt-cajon')) { sessionStorage.removeItem('jt-cajon'); setTimeout(abrir, 60) } } catch (e) {}
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible' && !d.open) enCola(refrescar) })
  }

  // ── los desplegables de la ficha: se abren y se cierran con una animación suave (sin JS, se abren igual, de golpe)
  function plegables(raiz) {
    raiz.querySelectorAll('details.plegable').forEach((d) => {
      if (d.dataset.listo) return
      d.dataset.listo = '1'
      const s = d.querySelector('summary'), c = d.querySelector('.plegable__cuerpo')
      if (!s || !c || quieto || !c.animate) return
      s.addEventListener('click', (e) => {
        e.preventDefault()
        if (d.dataset.moviendo) return
        d.dataset.moviendo = '1'
        const curva = 'cubic-bezier(.2, .7, .2, 1)'
        if (!d.open) {
          d.open = true
          const h = c.scrollHeight
          c.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 300, easing: curva }).onfinish = () => { delete d.dataset.moviendo }
        } else {
          d.classList.add('cerrando')
          const h = c.scrollHeight
          c.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 240, easing: curva }).onfinish = () => { d.open = false; d.classList.remove('cerrando'); delete d.dataset.moviendo }
        }
      })
    })
  }

  // ── la puerta: la contraseña, en una ventana encima (no empuja nada). Se cierra con la ×, tocando fuera o con Esc;
  // si la contraseña ha fallado, se abre sola con el error
  function llave() {
    const d = document.getElementById('llave'); if (!d || d.dataset.lista) return
    d.dataset.lista = '1'
    const abrir = () => { if (!d.open) d.showModal(); d.querySelector('input[type="password"]')?.focus() }
    document.querySelectorAll('[data-abrir-llave]').forEach((b) => b.addEventListener('click', abrir))
    d.querySelector('[data-cerrar-llave]')?.addEventListener('click', () => d.close())
    d.addEventListener('click', (e) => { if (e.target === d) d.close() })
    if (d.querySelector('.form__msg--error')) abrir()
  }

  // ── al cargar ────────────────────────────────────────────────
  const arrancar = (raiz = document) => {
    raiz.querySelectorAll('[data-arrastrable]').forEach(arrastrable)
    activarTodo(raiz); aparecer(raiz); pestanas(raiz)
    ficha(raiz.querySelector('.ficha')); archivo(raiz.querySelector('.archivo')); carrito(raiz.querySelector('.carrito')); llave(); plegables(raiz)
  }
  cajonListo()
  arrancar()
  // en el editor de temas, al cambiar una sección se vuelve a pintar
  document.addEventListener('shopify:section:load', (e) => arrancar(e.target))

  return { activar, arrastrable, aparecer, pintarCarrito, cajon: { abrir, cerrar, anadir, refrescar } }
})()
